import './branch-form-regions.scss';
import BranchFormRegions from './branch-form-regions';

export default BranchFormRegions;
